import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

export abstract class ModalBase {

    constructor(
        private modalService: NgbModal,
        private content: any
    ) {}

    open(): void {
        let modal = this.modalService.open(this.content, { backdrop: 'static' });
        modal.componentInstance.name = 'World';
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/modal/modal-base.ts